module.exports = __webpack_public_path__ + "img/As-Much-As-Possible.89a79c1e.jpg";